<mat-toolbar>
    <div class="logo" routerLink="/welcome">
        <mat-icon>settings</mat-icon>
        <h1>STORE ADMIN PORTAL</h1>
    </div>
</mat-toolbar>